<template>
  <base-modal
    head-img-url=""
    :hide-footer="true"
    :show-close="true"
    @close="handleClose"
    class="grade-export-modal"
  >
    <template #title><i class="title_ic"></i>一键导出成绩</template>
    <template #content>
      <div class="grade-export-content">
        <!-- 筛选条件区域 -->
        <div class="teacher-paper-search-bar">
          <!-- 查询条件区 -->
          <el-form :inline="true" class="teacher-paper-form">
            <el-form-item label="业务类型：">
              <el-select v-model="filters.level" placeholder="请选择" class="teacher-paper-select select-level" @change="handleLevelChange">
                <el-option :label="item.label" :value="item.id" v-for="(item,index) in EXAM_LEVEL_TYPE" :key="index" />
              </el-select>
            </el-form-item>
            <el-form-item label="考试名称：">
              <el-select
                v-model="filters.roundId"
                placeholder="请输入"
                class="teacher-paper-select select-round"
                filterable
                :loading="roundsLoading"
              >
                <!-- remote
                :remote-method="getRounds" -->
                <el-option :label="item.roundName" :value="item.id" v-for="item in examRoundList" :key="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="学校：">
              <el-select
                v-model="filters.schoolId"
                placeholder="请选择"
                class="teacher-paper-select"
                filterable
              >
                <el-option label="全部" value="" v-if="schoolList.length > 1" />
                <el-option :label="item.schoolName" :value="item.id" v-for="(item,index) in schoolList" :key="index" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-group">
          <el-button
            type="primary"
            @click="handleQuery"
            class="search-btn btn"
            :loading="exportLoading"
          >查询</el-button>
          <el-button
            @click="handleReset"
            class="reset-btn btn"
            :disabled="exportLoading"
          >重置</el-button>
        </div>

        <!-- 统计信息区域 -->
        <div class="stats-section empty" v-if="showEmpty">未查询到结果</div>
        <div class="stats-section" v-else-if="statistics">
          <p class="stats-text">
            筛选出<span class="highlight">{{ statistics.totalCount }}</span>条记录,
            其中有<span class="highlight">{{ statistics.unCheck }}</span>条状态为"待批改",
            <span class="highlight">{{ statistics.checking }}</span>条状态为"批改中",
            <span class="highlight">{{ statistics.checked }}</span>条状态为"成绩已核对"
          </p>

          <!-- 导出按钮区域 -->
          <div class="export-section">
            <el-button
              type="text"
              class="export-btn"
              icon="el-icon-download"
              :loading="exportLoading"
              @click="handleExport"
            >
              导出明细
            </el-button>
          </div>
        </div>
        <div class="stats-section empty" v-else-if="exportLoading">加载中...</div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/baseModal.vue';
import { Form, FormItem, Select, Option, Button } from 'element-ui';
import { getExamRounds, getUserExamRounds, getUserExamStatistics, getUserSchools, searchPaperList } from '@/api/qzTeacher';
import { CHECK_STATUS_MAP, EXAM_LEVEL_TYPE } from '@/common/constant/qz';
import { loadAllDataByPagination, exportToExcel, downloadUrl } from '@/common/js/excelUtils';
import dayjs from 'dayjs';

export default {
  name: 'GradeExportModal',
  components: {
    BaseModal,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-select': Select,
    'el-option': Option,
    'el-button': Button,
  },
  data() {
    return {
      EXAM_LEVEL_TYPE,
      filters: {
        level: 'MATHS_TALENTS_1',
        schoolId: '',
        roundId: '',
      },
      exportLoading: false,
      schoolList: [],
      examRoundList: [],
      roundsLoading: false, // 控制考试下拉框的加载状态
      showEmpty: false,
      statistics: null,
      excelUrl: null, // 存储生成的Excel文件URL
    }
  },

  created() {
    this.getSchools();
    this.getRounds();
  },
  methods: {
    handleLevelChange() {
      this.filters.roundId = '';
      this.getRounds();
    },
    getSchools() {
      return getUserSchools(['TEACHER', 'ADMIN']).then(res => {
        if(res.code === 200 && res.body?.schools){
          this.schoolList = (res.body?.schools || []).filter(item => item.id !== 0); // 过滤掉所有学校
          if (this.schoolList.length === 1) {
            this.filters.schoolId = this.schoolList[0].id;
          }
        }
      })
    },
    getRounds(query='') {
      // if (!query) return;
      this.roundsLoading = true;
      getExamRounds({
        roundName:query,
        level:this.filters.level
      }).then(res => {
        if(res.code === 200 && res.body?.examRounds){
          this.examRoundList = res.body?.examRounds || [];
        }
      }).finally(() => {
        this.roundsLoading = false;
      })
    },
    // 加载试卷列表并生成Excel URL
    loadUserExamRounds() {
      return new Promise((resolve, reject) => {
        // 使用分页加载所有数据
        const loadDataFn = async (pageNo, pageSize) => {
          try {
            const res = await getUserExamRounds({
              ...this.filters,
              isExport: 1,
              pageNo,
              pageSize,
            });

            if (res.code === 200 && res.body?.userExamRounds) {
              return {
                data: res.body.userExamRounds,
                total: res.body.totalCount
              };
            }
            return { data: [], total: 0 };
          } catch (error) {
            console.error('加载数据失败:', error);
            throw error;
          }
        };

        // 分页加载所有数据
        loadAllDataByPagination(loadDataFn, {
          pageSize: 1000,
          onProgress: (current, total) => {
            console.log(`加载进度: ${current}/${total}`);
          }
        }).then(allData => {
          // 定义Excel列配置
          const columns = [
            { key: 'roundName', title: '考试名称' },
            { key: 'title', title: '试卷名称' },
            { key: 'markStatus', title: '试卷状态', formatter: (val) => {
              return CHECK_STATUS_MAP[val]?.label || '未知';
            } },
            { key: 'username', title: '考生姓名' },
            { key: 'school.schoolName', title: '考生学校', },
            { key: 'startTime', title: '用户开始考试时间', formatter: (val) => {
              return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
            }},
            { key: 'endTime', title: '用户交卷时间', formatter: (val) => {
              return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
            }},
            { key: 'totalCostTime', title: '考试花费时间(分钟)', formatter: (val) => {
              // const duration = Math.floor((record.endTime - record.startTime) / 1000);
              // return `${duration / 60 }分钟`;
              return Math.floor(val / 60);
            }},
            {key:'questionTypeStatistics',title: '选择题得分', formatter: (val) => {
              return val.TEXT_CHOICE_QUESTION || 0
            }},
            {key:'questionTypeStatistics',title:'填空题得分',formatter: (val) => {
              return val.PICTURE_BLANK_FILLING  || 0
            }},
            {key:'questionTypeStatistics',title:'问答题得分',formatter: (val) => {
                return val.PICTURE_PROOF || 0
            }}
            // { key: 'totalPoints', title: '得分', formatter: (val) => val / 10},
          ];
          // 生成Excel文件URL
          this.excelUrl = exportToExcel(allData, columns, '成绩导出', {
            sheetName: '成绩数据'
          });
          console.log('Excel文件URL生成成功:', this.excelUrl);
          resolve(this.excelUrl);
        }).catch(error => {
          console.error('生成Excel文件失败:', error);
          reject(error);
        });
      });
    },
    // 加载统计数据
    loadStatistics() {
      return getUserExamStatistics({
        ...this.filters,
      }).then(res => {
        if (res.code === 200 && res.body.markStatusStatistics) {
          const data = res.body.markStatusStatistics;
          let unCheck = data[0] || 0;
          let checking = data[1] || 0;
          let checked = data[2] || 0;
          this.statistics = {
            unCheck,
            checking,
            checked,
            totalCount: unCheck + checking + checked,
          }
          return this.statistics.totalCount;
        }
        throw res;
      }).catch(e => {
        this.$message.error(e?.message || '获取统计数据失败');
        return Promise.reject()
      })
    },

    // 查询
    handleQuery() {
      if (this.exportLoading) return;
      if (!this.filters.roundId) {
        this.$message.warning('请选择考试名称');
        return;
      }
      this.exportLoading = true;
      this.showEmpty = false;
      this.statistics = null;
      this.clear();

      this.loadStatistics().then(() => {

        if (this.statistics?.totalCount === 0) {
          this.showEmpty = true;
          return;
        }
        return this.loadUserExamRounds();
      }).finally(() => {
        this.exportLoading = false;
      })

    },

    // 重置
    handleReset() {
      this.filters = {
        level: 'MATHS_TALENTS_1',
        schoolId: this.schoolList.length === 1 ? this.schoolList[0].id : '',
        roundId: '',
      };
    },

    // 导出
    handleExport() {
      if (!this.excelUrl) {
        this.$message.warning('请先查询数据');
        return;
      }

      const roundName = this.examRoundList.find(item => item.id === this.filters.roundId)?.roundName;
      // 生成文件名
      const filename = `【成绩导出】${roundName || '考试名字'}_${dayjs().format('YYYY-MM-DD')}`
      // 下载文件
      downloadUrl(this.excelUrl, filename);

      this.$message.success('导出成功');
    },

    // 关闭弹窗
    handleClose() {
      this.clear();
      this.$emit('close');
    },
    clear() {
      // 清理Excel URL
      if (this.excelUrl) {
        URL.revokeObjectURL(this.excelUrl);
        this.excelUrl = null;
      }
    },
  },

  // 组件销毁时清理URL
  beforeDestroy() {
    this.clear();
  }
}
</script>

<style scoped lang="less">
.grade-export-modal {
  .grade-export-content {
    width: 820px;
  }

  .btn-group{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 10px;
    .btn{
      width: 92px;
      height: 36px;
      border-radius: 90px;
      font-size: 14px;
      border: none;
    }
    .search-btn {
      color: #FFFFFF;
      background: #E60012;
      margin-right: 12px;
    }
    .reset-btn{
      color: #000000;
      background: #F2F3F5;
    }
  }
  .teacher-paper-search-bar{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .teacher-paper-form {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .teacher-paper-select {
      width: 180px;
      &.select-round {
        width: 180px;
      }
    }
  }

  .stats-section {
    margin-top: 36px;
    background: #F5F6F9;
    border-radius: 12px;
    min-height: 110px;
    padding: 20px;
    box-sizing: border-box;
    &.empty {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #4E5969;
    }
    .stats-text {
      font-size: 14px;
      color: #4E5969;
      line-height: 1.5;
      margin: 0;
      text-align: left;

      .highlight {
        color: #E60012;
        font-weight: 600;
        margin: 0 3px;
      }
    }
  }

  .export-section {
    display: flex;
    justify-content: flex-end;
    margin-top: 22px;
    .export-btn {
      color: #BD9F68;
      padding: 0 20px;
      font-size: 14px;

      .export-icon {
        width: 16px;
        height: 16px;
        display: inline-block;
        background: url('@/common/images/teacher/ic_download.png') center / contain no-repeat;
      }
    }
  }
}

// 覆盖baseModal的样式
.grade-export-modal {
  /deep/ .base-modal_cnt {
    min-height: 228px;
    padding: 40px;
  }
  /deep/ .base-modal_title {
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 600;
    color: #000000E5;
    margin-bottom: 36px;
    width: 100%;
    .title_ic {
      width: 24px;
      height: 24px;
      background: url('@/common/images/teacher/ic_export.png') center / contain no-repeat;
      margin-right: 6px;
    }
  }
  /deep/ .el-form-item__label {
    padding-right: 0;
  }
  /deep/ .el-form--inline .el-form-item {
    margin-bottom: 0;
  }
}
</style>